import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import TopupProduct from "../../../entities/productOrder/topup/TopupProduct";
import {ProductService} from "../../../service/topup/ProductService";

const ERROR_MAP = {
    error: ["ERROR_00_400_753"],
}

class EditTopupProductEnableStore {

    public topupProductId?: string;
    public topupProduct?: TopupProduct;
    public enable: boolean;
    public productId: string;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;
    public error?: string;

    constructor(commonStore: CommonStore, topupProductId?: string) {
        this.topupProductId = topupProductId;
        this.enable = false;
        this.productId = '';
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async loadTopupProduct() {
        if (!this.topupProductId) {
            return;
        }
        const response = await ProductService.getAll();
        if (response.success && response.data) {
            this.topupProduct = response.data.find(p => p.id === this.topupProductId);
            this.enable = !!this.topupProduct?.enabled;
        }
        this.commonStore.processErrors(response);
    }

    @action
    public async openModal() {
        this.loading = true;
        await this.loadTopupProduct();
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async save(): Promise<boolean> {
        if (!this.topupProductId) {
            return false;
        }
        this.loading = true;
        const response = await ProductService.updateEnabled(this.topupProductId, this.enable, this.enable ? this.productId : undefined);
        this.commonStore.processErrors(response);
        this.processError(response.error);
        this.loading = false;
        return response.success;
    }

    processError(error?: string) {
        this.error = undefined;
        if (error && ERROR_MAP.error.includes(error)) {
            this.error = error;
        }
    }
}

export default EditTopupProductEnableStore;
